// App.js
import React from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Dashboard from "./components/Dashboard";
import { AppShell, getUserEmail } from "@1823-partners/core";
import api from "./api";

export default function App() {
  return (
    <AppShell appName="blotter" title="Blotter" api={api}>
      {({ userInfo }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Dashboard userId={getUserEmail(userInfo)} />
        </LocalizationProvider>
      )}
    </AppShell>
  );
}
